export default function validateMinDate() {
  return {
    require: 'ngModel',
    link($scope, $element, $attrs, $ngModelController) {
      $ngModelController.$validators['min-date'] = (modelValue) => {
        const minDate = $scope.$eval($attrs.validateMinDate);
        return minDate && modelValue ? modelValue >= minDate : true;
      };

      $scope.$watch($attrs.validateMinDate, () => $ngModelController.$validate());
    },
  };
}
